import React, { Component } from 'react'
import { graphql } from 'react-apollo'
import { eventsQueryAgg } from '@/graphql/queries/event'
import { GC_USER_ID } from '@/constants'
import Loading from '../modals/Loading'
import { OrdinalFrame } from 'semiotic'
import * as moment from 'moment'
import * as Alasql from 'alasql'

const generate = (n, x) => {
  var arr = []
  for (var i = 0; i < n; i++) {
    arr.push(i * x)
  }
  return arr
}

@graphql(eventsQueryAgg, {
  name: 'eventsQueryAgg',
  options: ownProps => ({
    variables: {
      userId: global.localStorage.getItem(GC_USER_ID),
      dayS: ownProps.dayS,
      dayE: ownProps.dayE
    },
    refetchQueries: ['eventsQueryAgg']
  })
})
export default class AlchemyTimelineWeekly extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  addBlankDate = data => {
    var iDateStart = moment(new Date(this.props.dayS)).startOf('week')
    var iDateEnd = moment(new Date(this.props.dayS)).endOf('week')
    var daysWeek = iDateEnd.diff(iDateStart, 'days') + 1

    for (var i = 0; i < daysWeek; i++) {
      var blankDate = iDateStart
      var isSame = false

      for (var j in data) {
        if (
          moment(new Date(data[j].date)).format('l') === blankDate.format('l')
        ) {
          isSame = true
        }
      }
      if (!isSame) {
        data.splice(i, 0, {
          date: blankDate.format('l'),
          minutes: 0,
          type: 'blank'
        })
        isSame = false
      }

      iDateStart = moment(blankDate).add(1, 'd')
    }

    return data
  }

  render() {
    if (this.props.eventsQueryAgg.loading) {
      return <Loading />
    }
    var events = []
    if (this.props.eventsQueryAgg.allEvents) {
      this.props.eventsQueryAgg.allEvents.map(e =>
        events.push({
          id: e.id,
          date: moment(new Date(e.completedAt)).format('l'),
          tid: e.tracker.id,
          name: e.tracker.name,
          cat: e.tracker.category,
          color: e.tracker.color,
          minutes: e.minutes
        })
      )
    }
    var eventsByCat = Alasql(
      'SELECT cat, color, date, SUM(CAST([minutes] AS INT)) AS [minutes]  FROM ? GROUP BY cat, color, date ORDER BY CASE WHEN cat = "Very Productive" THEN "1" WHEN cat = "Productive" THEN "2" ELSE cat END ASC',
      [events]
    )
    eventsByCat = this.addBlankDate(eventsByCat)
    var eventsKPI = eventsByCat.filter(e => e.cat !== 'Maintenance')
    eventsKPI = this.addBlankDate(eventsKPI)

    return (
      <div>
        <span>
          Week: {moment(new Date(this.props.dayS)).format('w')} ({moment(
            new Date(this.props.dayS)
          ).format('M/D')}~{moment(new Date(this.props.dayE)).format('M/D')})
        </span>
        <div
          style={{
            position: 'relative',
            textAlign: 'center',
            marginLeft:
              -this.props.width * 0.07 +
              (window.innerWidth - this.props.width / 1.28) / 2
          }}
        >
          <OrdinalFrame
            data={eventsKPI}
            size={[this.props.width / 1.28, this.props.height / 1.28]}
            type="bar"
            oAccessor={d => moment(new Date(d.date)).day()}
            sortO={(a, b) => a > b}
            rAccessor="minutes"
            rExtent={[0, 720]}
            style={d => ({ fill: d.color, stroke: 'white' })}
            axis={[
              {
                orient: 'left',
                tickFormat: d => (
                  <text
                    key={`tick-${d}`}
                    style={{ fill: '#cecece', textAnchor: 'end', fontSize: 10 }}
                    y={-2}
                  >
                    {d / 60 + 'h'}
                  </text>
                ),
                tickValues: generate(24, 60),
                baseline: false,
                tickLineGenerator: ({ xy }) => (
                  <path
                    key={`tickLine-${xy.value}`}
                    style={{
                      stroke:
                        xy.value === 480
                          ? 'rgba(147, 112, 219,0.3)'
                          : 'rgba(0, 0, 0,0.03) '
                    }}
                    d={`M${xy.x1},${xy.y1}L${xy.x2},${xy.y1}L${xy.x2},${
                      xy.y1
                    }L${xy.x1},${xy.y1}Z`}
                  />
                )
              }
            ]}
            margin={{
              left: this.props.width / 7.5,
              top: this.props.height / 24,
              right: this.props.width / 10.6,
              bottom: this.props.height / 9.6
            }}
            oLabel={d => (
              <text
                key={`label-${d}`}
                fill="#cecece"
                textAnchor="middle"
                fontSize={14}
              >
                {d === 0
                  ? 'S'
                  : d === 1
                    ? 'M'
                    : d === 2
                      ? 'T'
                      : d === 3 ? 'W' : d === 4 ? 'T' : d === 5 ? 'F' : 'S'}
              </text>
            )}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ChartTypes/AlchemyTimelineWeekly.js